// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__8V2Ll","gfeWrapper":"CalendarEvent_gfeWrapper__OxZuJ"};